import {alias, createModelSchema, reference} from "serializr";

import {TriggerBase} from "./core/TriggerBase";
import {TriggerKind} from "./core/TriggerKind";
import {TriggerScope} from "./core/TriggerScope";
import {TriggerSchema} from "./core/TriggerSchema";

export class TriggerGroup extends TriggerBase {

    constructor() {
        super(TriggerKind.TRIGGER_GROUP);
        this._amount = 1;
        this._items = [];
    }

    get items() {
        return this._items;
    }

    set items(value) {
        this._items = value;
    }

    get visible() {
        for (let item of this.items) {
            if (item.visible) {
                return true;
            }
        }
        return false;
    }

    valid() {

        if (!super.valid()) {
            return false;
        }

        if (!this.items || this.items.length < 2) {
            return false;
        }

        if (this.items.some(v => !v || !v.valid())) {
            return false;
        }

        if (this.items.filter(v => v.visible).length > 1) {
            return false;
        }


        return true;
    }

    clone(target = undefined) {
        if (!target) {
            return super.clone(new TriggerGroup());
        } else if (target instanceof TriggerGroup) {
            return super.clone(target);
        } else {
            console.assert(false);
            return undefined;
        }
    }
}

export class TriggerGroupScope extends TriggerScope {

    static _values = [
        new TriggerGroupScope(1, "OR")
    ];

    static getValues() {
        return this._values;
    }

    static getValue(id) {
        let value = this._values.find(v => v.id === id) || null;
        console.assert(value, "unknown id: " + id);
        return value;
    }

    static schema() {
        return reference("id", (id, cb) => {
            return cb(null, TriggerGroupScope.getValue(id));
        });
    }

    clone(target = undefined) {
        if (!target) {
            return super.clone(new TriggerGroupScope());
        } else if (target instanceof TriggerGroupScope) {
            return super.clone(target);
        } else {
            console.assert(false);
            return undefined;
        }
    }
}

createModelSchema(TriggerGroup, {
    _scope: alias("scope", TriggerGroupScope.schema()),
    _items: alias("items", TriggerSchema.custom())
});
